export const Void = () => null;
